function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Fragment, useMemo } from 'react';
import { useTableCep } from '../implements/implement';
import { useTable } from '../context';
import { useTableColumnsWidth } from '../implements/size';
export function TableShadow(props) {
  var width = props.width,
      height = props.height,
      theadHeight = props.theadHeight,
      theadSticky = props.theadSticky,
      _props$scrollBarWidth = props.scrollBarWidth,
      scrollBarWidth = _props$scrollBarWidth === void 0 ? 0 : _props$scrollBarWidth;
  var cep = useTableCep();
  var context = useTable();
  var columnsWidth = useTableColumnsWidth();
  return useMemo(function () {
    var style = {
      width: "".concat(width, "px")
    };
    var direction = cep.direction,
        elem = cep.elem;
    var rtl = direction === 'rtl';
    var columns = context.columns;
    var widthMap = columnsWidth.widthMap;
    var stickyStart = columns.filter(function (col) {
      return col.fixed === 'start';
    }).reduce(function (total, col) {
      return total + (widthMap.get(col) || 0);
    }, 0);
    var stickyEnd = columns.filter(function (col) {
      return col.fixed === 'end';
    }).reduce(function (total, col) {
      return total + (widthMap.get(col) || 0);
    }, 0);
    stickyEnd = stickyEnd && stickyEnd + scrollBarWidth;
    var noneSticky = width - stickyStart - stickyEnd - 30;
    var elemSupport = elem('ShadowSupport');
    var elemShadowStart = elem('ColumnShadow', {
      start: true
    });
    var elemShadowEnd = elem('ColumnShadow', {
      end: true
    });

    var getNodes = function getNodes(height) {
      var nodes = [];

      if (stickyStart > 0) {
        var _style;

        var distance = "".concat(stickyStart, "px");
        nodes.push(React.createElement("div", {
          key: "support-start",
          className: elemSupport,
          style: {
            width: distance
          }
        }), React.createElement("div", {
          key: "shadow-start",
          className: elemShadowStart,
          style: (_style = {}, _defineProperty(_style, rtl && 'right' || 'left', distance), _defineProperty(_style, "height", height), _style)
        }));
      }

      if (noneSticky > 0) {
        nodes.push(React.createElement("div", {
          key: "support-center",
          className: elemSupport,
          style: {
            width: "".concat(noneSticky, "px")
          }
        }));
      }

      if (stickyEnd > 0) {
        var _style2;

        var _distance = "".concat(stickyEnd, "px");

        nodes.push(React.createElement("div", {
          key: "shadow-end",
          className: elemShadowEnd,
          style: (_style2 = {}, _defineProperty(_style2, rtl && 'left' || 'right', _distance), _defineProperty(_style2, "height", height), _style2)
        }), React.createElement("div", {
          key: "support-end",
          className: elemSupport,
          style: {
            width: _distance
          }
        }));
      }

      return nodes;
    };

    return React.createElement(Fragment, null, !!theadHeight && React.createElement("div", {
      key: "head-shadow",
      className: elem('Shadow', {
        head: true,
        sticky: theadSticky
      }),
      style: style
    }, getNodes("".concat(theadHeight, "px"))), !!height && React.createElement("div", {
      key: "body-shadow",
      className: elem('Shadow', {
        sticky: true
      }),
      style: style
    }, getNodes("".concat(height, "px"))));
  }, [width, height, theadHeight, theadSticky, cep, context, columnsWidth]);
}